/**
 * File to import all vue components at once
 * 
 * See https://vuejs.org/v2/guide/components-registration.html#Automatic-Global-Registration-of-Base-Components
 * (Slightly adjusted RegEx to import all components)
 */
import Vue from 'vue'

// Helper function to replace lodash
function upperFirst(str) {
  return str.replace(/^\w/, function (chr) {
    return chr.toUpperCase();
  });
} 

// Helper function to replace lodash
function camelCase(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
    return index == 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+/g, '');
}

const requireComponent = require.context(
  // The relative path of the components folder
  '../components',
  // Whether or not to look in subfolders
  true,
  // The regular expression used to match all components
  /[A-Z]\w+\.(vue|js)$/
  )
  
  requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName)

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )

  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  )
})